module.exports = __webpack_public_path__ + "reticle-6490ecbb61185e86e62dca0845cf2dcf.png";